var React = require('react');

function DesktopIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".desktop-icon-svg-1{fill:#b4b4b4;}")),React.createElement("path",{"className":"desktop-icon-svg-1","d":"M11,0H3A3,3,0,0,0,0,3V8a3,3,0,0,0,3,3H6v2H3v1h8V13H8V11h3a3,3,0,0,0,3-3V3a3,3,0,0,0-3-3ZM3,9A1,1,0,0,1,2,8V3A1,1,0,0,1,3,2h8a1,1,0,0,1,1,1V8a1,1,0,0,1-1,1Z","key":1}),React.createElement("path",{"className":"desktop-icon-svg-1","d":"M7,4A1,1,0,0,0,6,5V6A1,1,0,0,0,8,6V5A1,1,0,0,0,7,4Z","key":2})]);
}

DesktopIcon.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 14 14","width":"14","height":"14"};

module.exports = DesktopIcon;

DesktopIcon.default = DesktopIcon;
